import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { catalogProducts } from '@/mocks/catalog';
import { useStaggerReveal, useScrollReveal } from '@/hooks/useScrollReveal';

interface SubcategoryGridProps {
  sectionName: string;
  categories: string[];
  color: string;
  glow: string;
  bg: string;
}

const CATEGORY_IMAGES: Record<string, string> = {
  'Сердце и сосуды':        'https://public.readdy.ai/ai/img_res/ce6335005a5b0b2959c98af9bf825954.jpg',
  'Обезболивающие':         'https://readdy.ai/api/search-image?query=pain%20relief%20analgesic%20medicine%20tablets%20blister%20pack%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=400&height=300&seq=subcat-pain&orientation=landscape',
  'Желудок и кишечник':     'https://readdy.ai/api/search-image?query=gastrointestinal%20stomach%20medicine%20capsules%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-gastro&orientation=landscape',
  'Простуда и грипп':       'https://readdy.ai/api/search-image?query=cold%20flu%20medicine%20tablets%20sachets%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-cold&orientation=landscape',
  'Антибиотики':            'https://readdy.ai/api/search-image?query=antibiotic%20capsules%20blister%20pack%20orange%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-anti&orientation=landscape',
  'Аллергия':               'https://readdy.ai/api/search-image?query=antihistamine%20allergy%20medicine%20tablets%20violet%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-allergy&orientation=landscape',
  'Нейропротекторы':        'https://readdy.ai/api/search-image?query=neuroprotector%20brain%20supplement%20capsules%20violet%20purple%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-neuro&orientation=landscape',
  'Витамины':               'https://readdy.ai/api/search-image?query=vitamins%20colorful%20capsules%20bottles%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20supplement%20minimal%20clean%20photography&width=400&height=300&seq=subcat-vit&orientation=landscape',
  'Мультивитамины':         'https://readdy.ai/api/search-image?query=multivitamin%20complex%20tablets%20colorful%20box%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20supplement%20minimal%20clean%20photography&width=400&height=300&seq=subcat-multi&orientation=landscape',
  'Минералы':               'https://readdy.ai/api/search-image?query=minerals%20calcium%20magnesium%20supplement%20tablets%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-min&orientation=landscape',
  'Омега и жирные кислоты': 'https://readdy.ai/api/search-image?query=omega%203%20fish%20oil%20capsules%20supplement%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-omega&orientation=landscape',
  'Антиоксиданты':          'https://readdy.ai/api/search-image?query=antioxidant%20coenzyme%20Q10%20supplement%20capsules%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-antioxid&orientation=landscape',
  'Пробиотики':             'https://readdy.ai/api/search-image?query=probiotic%20lactobacillus%20supplement%20capsules%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-probio&orientation=landscape',
  'Красота и здоровье':     'https://readdy.ai/api/search-image?query=beauty%20vitamins%20biotin%20collagen%20supplement%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-beauty&orientation=landscape',
  'Спортивное питание':     'https://readdy.ai/api/search-image?query=sports%20nutrition%20supplement%20protein%20capsules%20orange%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-sport&orientation=landscape',
  'Уход за лицом':          'https://readdy.ai/api/search-image?query=face%20skincare%20cream%20serum%20bottles%20tubes%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20beauty%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-face&orientation=landscape',
  'Уход за телом':          'https://readdy.ai/api/search-image?query=body%20care%20cream%20lotion%20tubes%20bottles%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20beauty%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-body&orientation=landscape',
  'Уход за волосами':       'https://readdy.ai/api/search-image?query=hair%20care%20shampoo%20conditioner%20bottles%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20beauty%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-hair&orientation=landscape',
  'Иммунитет':              'https://readdy.ai/api/search-image?query=homeopathic%20immune%20system%20tablets%20granules%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-immune&orientation=landscape',
  'Нервная система':        'https://readdy.ai/api/search-image?query=homeopathic%20nervous%20system%20stress%20relief%20tablets%20violet%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-nerve&orientation=landscape',
  'Суставы и мышцы':        'https://readdy.ai/api/search-image?query=homeopathic%20joint%20muscle%20ointment%20gel%20orange%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-joint&orientation=landscape',
  'Однодневные линзы':      'https://readdy.ai/api/search-image?query=daily%20contact%20lenses%20blister%20pack%20box%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20optical%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-daily&orientation=landscape',
  'Месячные линзы':         'https://readdy.ai/api/search-image?query=monthly%20contact%20lenses%20box%20case%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20optical%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-monthly&orientation=landscape',
  'Растворы и уход':        'https://readdy.ai/api/search-image?query=contact%20lens%20solution%20bottle%20case%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20optical%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-solution&orientation=landscape',
  'Перевязочные материалы': 'https://readdy.ai/api/search-image?query=bandage%20gauze%20medical%20dressing%20roll%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20medical%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-bandage&orientation=landscape',
  'Тонометры':              'https://readdy.ai/api/search-image?query=blood%20pressure%20monitor%20tonometer%20device%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20medical%20device%20minimal%20clean%20photography&width=400&height=300&seq=subcat-tono&orientation=landscape',
  'Термометры':             'https://readdy.ai/api/search-image?query=digital%20thermometer%20medical%20device%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-thermo&orientation=landscape',
  'Средства защиты':        'https://readdy.ai/api/search-image?query=medical%20gloves%20mask%20protective%20equipment%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20medical%20product%20minimal%20clean%20photography&width=400&height=300&seq=subcat-protect&orientation=landscape',
  'Ингаляторы':             'https://readdy.ai/api/search-image?query=nebulizer%20inhaler%20medical%20device%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20equipment%20minimal%20clean%20photography&width=400&height=300&seq=subcat-inhaler&orientation=landscape',
  'Глюкометры':             'https://readdy.ai/api/search-image?query=glucometer%20blood%20glucose%20meter%20device%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20equipment%20minimal%20clean%20photography&width=400&height=300&seq=subcat-gluco&orientation=landscape',
  'Пульсоксиметры':         'https://readdy.ai/api/search-image?query=pulse%20oximeter%20finger%20device%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20equipment%20minimal%20clean%20photography&width=400&height=300&seq=subcat-pulse&orientation=landscape',
  'Массажёры':              'https://readdy.ai/api/search-image?query=massager%20neck%20shoulder%20device%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20wellness%20equipment%20minimal%20clean%20photography&width=400&height=300&seq=subcat-massage&orientation=landscape',
};

const CATEGORY_ICONS: Record<string, string> = {
  'Сердце и сосуды':        'ri-heart-pulse-line',
  'Обезболивающие':         'ri-medicine-bottle-line',
  'Желудок и кишечник':     'ri-drop-line',
  'Простуда и грипп':       'ri-temp-cold-line',
  'Антибиотики':            'ri-virus-line',
  'Аллергия':               'ri-leaf-line',
  'Нейропротекторы':        'ri-brain-line',
  'Витамины':               'ri-sun-line',
  'Мультивитамины':         'ri-capsule-line',
  'Минералы':               'ri-flask-line',
  'Омега и жирные кислоты': 'ri-water-flash-line',
  'Антиоксиданты':          'ri-shield-star-line',
  'Пробиотики':             'ri-microscope-line',
  'Красота и здоровье':     'ri-sparkling-2-line',
  'Спортивное питание':     'ri-run-line',
  'Уход за лицом':          'ri-user-smile-line',
  'Уход за телом':          'ri-body-scan-line',
  'Уход за волосами':       'ri-scissors-line',
  'Иммунитет':              'ri-shield-check-line',
  'Нервная система':        'ri-mental-health-line',
  'Суставы и мышцы':        'ri-walk-line',
  'Однодневные линзы':      'ri-eye-line',
  'Месячные линзы':         'ri-eye-2-line',
  'Растворы и уход':        'ri-flask-line',
  'Перевязочные материалы': 'ri-first-aid-kit-line',
  'Тонометры':              'ri-heart-line',
  'Термометры':             'ri-temp-hot-line',
  'Средства защиты':        'ri-shield-line',
  'Ингаляторы':             'ri-lungs-line',
  'Глюкометры':             'ri-drop-line',
  'Пульсоксиметры':         'ri-pulse-line',
  'Массажёры':              'ri-hand-heart-line',
};

const SubcategoryGrid = ({ sectionName, categories, color, glow, bg }: SubcategoryGridProps) => {
  const [hoveredCat, setHoveredCat] = useState<string | null>(null);

  // +1 for the "all products" card at the end
  const totalCards = categories.length + 1;
  const { containerRef, visibleItems } = useStaggerReveal(totalCards, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <div>
      {/* Section header */}
      <div
        ref={headerRef as React.RefObject<HTMLDivElement>}
        className="flex items-center justify-between mb-6"
        style={{
          opacity: headerVisible ? 1 : 0,
          transform: headerVisible ? 'translateY(0)' : 'translateY(18px)',
          transition: 'opacity 0.5s ease, transform 0.5s ease',
        }}
      >
        <div>
          <div className="flex items-center gap-3 mb-1">
            <span className="font-mono text-xs tracking-[0.2em]" style={{ color: `${color}80` }}>ПОДКАТЕГОРИИ</span>
            <div className="h-px w-10" style={{ background: `${color}30` }} />
          </div>
          <h2 className="font-orbitron font-bold text-xl text-white">
            Выберите подкатегорию
          </h2>
        </div>
        <Link
          to={`/catalog?section=${encodeURIComponent(sectionName)}`}
          className="whitespace-nowrap flex items-center gap-2 px-4 py-2 rounded-full font-mono text-xs cursor-pointer transition-all duration-300"
          style={{ background: `${color}12`, border: `1px solid ${color}35`, color }}
          onMouseEnter={e => { (e.currentTarget as HTMLElement).style.boxShadow = `0 0 14px ${glow}`; }}
          onMouseLeave={e => { (e.currentTarget as HTMLElement).style.boxShadow = 'none'; }}
        >
          Все товары раздела <i className="ri-arrow-right-line" />
        </Link>
      </div>

      {/* Grid */}
      <div
        ref={containerRef as React.RefObject<HTMLDivElement>}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
      >
        {categories.map((cat, idx) => {
          const count = catalogProducts.filter(p => p.section === sectionName && p.category === cat).length;
          const isHovered = hoveredCat === cat;
          const icon = CATEGORY_ICONS[cat] ?? 'ri-grid-line';
          const img = CATEGORY_IMAGES[cat];
          const isVisible = visibleItems[idx];

          return (
            <Link
              key={cat}
              to={`/catalog?section=${encodeURIComponent(sectionName)}&category=${encodeURIComponent(cat)}`}
              className="relative overflow-hidden rounded-xl cursor-pointer group"
              style={{
                border: `1px solid ${isHovered ? color : color + '20'}`,
                background: '#0a0a14',
                boxShadow: isHovered ? `0 0 20px ${glow}` : 'none',
                minHeight: '200px',
                // Stagger reveal
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(28px) scale(0.97)',
                transition: `opacity 0.45s ease ${idx * 60}ms, transform 0.45s ease ${idx * 60}ms, border-color 0.3s ease, box-shadow 0.3s ease`,
              }}
              onMouseEnter={() => setHoveredCat(cat)}
              onMouseLeave={() => setHoveredCat(null)}
            >
              {/* Background image */}
              {img && (
                <img
                  src={img}
                  alt={cat}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110 opacity-40 group-hover:opacity-60"
                />
              )}
              <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(5,5,8,0.9) 0%, rgba(5,5,8,0.5) 60%, rgba(5,5,8,0.2) 100%)' }} />

              {/* Top glow line */}
              <div
                className="absolute top-0 left-0 right-0 h-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ background: `linear-gradient(90deg, transparent, ${color}, transparent)` }}
              />

              {/* Neon corner accent */}
              <div
                className="absolute bottom-0 right-0 w-16 h-16 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{
                  background: `radial-gradient(circle at bottom right, ${color}20 0%, transparent 70%)`,
                }}
              />

              {/* Content */}
              <div className="relative z-10 p-5 flex flex-col" style={{ minHeight: '200px' }}>
                {/* Icon */}
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-xl transition-all duration-300 group-hover:scale-110"
                  style={{
                    background: bg,
                    border: `1px solid ${color}35`,
                    boxShadow: isHovered ? `0 0 12px ${glow}` : 'none',
                  }}
                >
                  <i className={`${icon} text-lg`} style={{ color, filter: `drop-shadow(0 0 4px ${color})` }} />
                </div>

                {/* Spacer */}
                <div className="flex-1" />

                {/* Bottom content */}
                <div className="mt-4">
                  <h3
                    className="font-orbitron font-bold text-sm mb-1 leading-tight transition-colors duration-300"
                    style={{ color: isHovered ? color : '#fff' }}
                  >
                    {cat}
                  </h3>
                  <div className="flex items-center justify-between mt-2">
                    <span
                      className="font-mono text-[11px] transition-colors duration-300"
                      style={{ color: isHovered ? `${color}99` : 'rgba(255,255,255,0.35)' }}
                    >
                      {count > 0 ? `${count} товаров` : 'Смотреть'}
                    </span>
                    <div
                      className="w-7 h-7 flex items-center justify-center rounded-full transition-all duration-300 translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100"
                      style={{ background: color, color: '#050508' }}
                    >
                      <i className="ri-arrow-right-line text-xs" />
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}

        {/* "All products" card */}
        {(() => {
          const allIdx = categories.length;
          const isVisible = visibleItems[allIdx];
          return (
            <Link
              to={`/catalog?section=${encodeURIComponent(sectionName)}`}
              className="relative overflow-hidden rounded-xl cursor-pointer group flex flex-col items-center justify-center"
              style={{
                border: `1px dashed ${color}30`,
                background: `${color}05`,
                minHeight: '200px',
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(28px) scale(0.97)',
                transition: `opacity 0.45s ease ${allIdx * 60}ms, transform 0.45s ease ${allIdx * 60}ms, border-color 0.3s ease, background 0.3s ease`,
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLElement).style.borderColor = `${color}60`;
                (e.currentTarget as HTMLElement).style.background = `${color}0a`;
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLElement).style.borderColor = `${color}30`;
                (e.currentTarget as HTMLElement).style.background = `${color}05`;
              }}
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-full mb-3 transition-all duration-300 group-hover:scale-110"
                style={{ background: bg, border: `1px solid ${color}35` }}
              >
                <i className="ri-apps-2-line text-xl" style={{ color }} />
              </div>
              <span className="font-orbitron font-bold text-sm text-center" style={{ color }}>
                Все товары
              </span>
              <span className="font-mono text-[11px] mt-1" style={{ color: 'rgba(255,255,255,0.3)' }}>
                раздела
              </span>
            </Link>
          );
        })()}
      </div>
    </div>
  );
};

export default SubcategoryGrid;
